import * as actionTypes from "../actions/types";
import produce from "immer";

const initialState = {
  isProfileView: false,
};

let newData = [];
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  console.log("profileViewReducer", payload);
  switch (type) {
    case actionTypes.OPEN_PROFILE_VIEW:
      draft.isProfileView = true;
      return draft;
    case actionTypes.CLOSE_PROFILE_VIEW:
      draft.isProfileView = false;
      return draft;
    default:
      return draft;
  }
});
